import React from 'react';

/**
 * ReportsPanelBulkActions
 * Bulk actions toolbar for ReportsPanel (admin/teacher roles)
 * Props:
 * - selected: array of selected report IDs
 * - onSelectAll: fn()
 * - onDeselectAll: fn()
 * - onDelete: fn()
 * - onExport: fn(format)
 */
const ReportsPanelBulkActions = ({ selected = [], onSelectAll, onDeselectAll, onDelete, onExport }) => {
  return (
    <div className="reports-bulk-actions" style={{display:'flex',gap:12,alignItems:'center',marginBottom:16}}>
      <span>{selected.length} selected</span>
      <button onClick={onSelectAll}>Select All</button>
      <button onClick={onDeselectAll}>Deselect</button>
      <button onClick={onDelete} disabled={selected.length === 0}>Delete</button>
      <button onClick={() => onExport('csv')} disabled={selected.length === 0}>Export CSV</button>
      <button onClick={() => onExport('pdf')} disabled={selected.length === 0}>Export PDF</button>
    </div>
  );
};

export default ReportsPanelBulkActions;
